module.exports = __webpack_public_path__ + "static/logo_myteam-2d029133dd59ea998244b66764fc8c6c.png";